import { TreeNode } from 'primeng/api';
import { List } from 'linqts-es-module';
import { Study } from '@models/study.model';
import { Country } from '@models/country.model';
import { CountryCity } from '@models/countryCity.model';
import { Currency } from '@models/currency.model';
import { Lookup } from '@models/lookup.model';
import { KeyValuePair } from '@models/keyValuePair.model';
import { RegionCountry } from '@models/regioncountry.model';
import { Industry } from '@models/industry.model';
import { FunctionType } from '@models/functionType.model';
import { UserStudy } from '@models/userStudy.model';
import { Role } from '@models/role.model';
import { Ratio } from '@models/ratio.model';

export class StudyViewModel {
  constructor() {
    this.otherIndustryId = 0;
  }
  private temp_regionCountryData: List<string>;

  study: Study = new Study();

  countriesProjectOffice: Country[] = [];
  countryCities: CountryCity[] = [];
  currencies: Currency[] = [];
  currencyUnits: Lookup[] = [];
  years: number[] = [];
  fiscalYears: KeyValuePair<number, string>[] = [];
  selectedBenchmarkCountries: string[] = [];
  ratios: Ratio[] = [];
  selectedTestedPartyCountries: string[] = [];
  regionCountryList: List<RegionCountry> = new List<RegionCountry>();
  otherIndustryId: number;
  industries: Industry[] = [];
  industryTypes: Lookup[] = [];
  functionTypes: FunctionType[] = [];
  defaultAveragingMethods: Lookup[] = [];
  monthsBack: number[] = [];
  regionCountries_multi: TreeNode[] = [];
  testedpartyregionCountries_multi: TreeNode[] = [];
  selectedRatios: number[] = [];
  // to display the list of user who has been selected as team member
  userList: UserStudy[] = [];
  roles: Role[] = [];

  financialResultsFormatting: Lookup[] = [];
  studySettings: Lookup[] = [];
  isWorldRegionsEnabledOnTestedParty: boolean;
  itemsPerPageOptions: number[] = [10, 30, 50];

  get OfficeCountryNameText(): string {
    if (this.countriesProjectOffice.length > 0) {
      if (this.study.projectOfficeCountryId && this.study.projectOfficeCountryId > 0) {
        const v = this.countriesProjectOffice.find((a) => a.countryId === this.study.projectOfficeCountryId);
        return v ? v.countryName : '';
      }
    }
    return '';
  }

  get OfficeCityNameText(): string {
    if (this.countryCities.length > 0) {
      if (this.study.projectOfficeCityId && this.study.projectOfficeCityId > 0) {
        const v = this.countryCities.find((a) => a.countryCityId === this.study.projectOfficeCityId);
        return v ? v.city : '';
      }
    }
    return '';
  }

  get StudyReferenceCurrencyText(): string {
    if (this.currencies.length > 0) {
      if (this.study.currencyId && this.study.currencyId > 0) {
        const v = this.currencies.find((a) => a.currencyId === this.study.currencyId);
        return v ? v.currencyName : '';
      }
    }
    return '';
  }

  get StudyCurrencyUnitsText(): string {
    if (this.currencyUnits.length > 0) {
      if (this.study.currencyUnitId && this.study.currencyUnitId > 0) {
        const v = this.currencyUnits.find((a) => a.lookupId === this.study.currencyUnitId);
        return v ? v.displayText : '';
      }
    }
    return '';
  }

  get FiscalYearText(): string {
    if (this.fiscalYears.length > 0) {
      if (this.study.fiscalYear && this.study.fiscalYear > 0) {
        const v = this.fiscalYears.find((a) => a.key === this.study.fiscalYear);
        return v ? v.value : '';
      }
    }
    return '';
  }

  get FunctionText(): string {
    if (this.functionTypes.length > 0) {
      if (this.study.functionId && this.study.functionId > 0) {
        const v = this.functionTypes.find((a) => a.functionId === this.study.functionId);
        return v ? v.functionName : '';
      }
    }
    return '';
  }

  get IndustryText(): string {
    if (this.industries.length > 0) {
      if (this.study.industryId && this.study.industryId > 0) {
        const v = this.industries.find((a) => a.industryId === this.study.industryId);
        return v ? v.industryName : '';
      }
    }
    return '';
  }

  get displayTestedPartyRegionCountry(): TreeNode[] {
    if (this.selectedTestedPartyCountries && this.selectedTestedPartyCountries.length > 0 && this.regionCountryList.Count() > 0) {
      this.temp_regionCountryData = new List<string>();

      this.temp_regionCountryData.AddRange(this.selectedTestedPartyCountries);

      const limitData = this.regionCountryList.Where((a) => this.temp_regionCountryData.Any((b) => b === a.regionCountryId.toString())).ToList();

      const filtered = limitData
        .Select((a) => a.region)
        .DistinctBy((a) => a.regionId)
        .OrderBy((a) => a.displayOrder)
        .ToList();

      const result = filtered
        .GroupJoin(
          limitData,
          (k1) => k1.regionId,
          (k2) => k2.regionId,
          (ctry, k) => ({
            label: ctry.regionName, // .trim().replace(' ', '')
            data: '0',
            children: k.Select((a) => ({ label: a.country.countryName, data: a.regionCountryId.toString() })).ToArray(),
          })
        )
        .ToArray();

      return result as TreeNode[];
    }

    return [];
  }

  get displayBenchmarkRegionCountry(): TreeNode[] {
    if (this.selectedBenchmarkCountries && this.selectedBenchmarkCountries.length > 0 && this.regionCountryList.Count() > 0) {
      this.temp_regionCountryData = new List<string>();

      this.temp_regionCountryData.AddRange(this.selectedBenchmarkCountries);

      const limitData = this.regionCountryList.Where((a) => this.temp_regionCountryData.Any((b) => b === a.countryId.toString())).ToList();

      const filtered = limitData
        .Select((a) => a.region)
        .DistinctBy((a) => a.regionId)
        .OrderBy((a) => a.regionName.toUpperCase())
        .ToList();

      // display Global region first
      const globalRegion = filtered.Where((r) => r.regionName == 'Global').FirstOrDefault();
      filtered.Remove(globalRegion);
      filtered.Insert(0, globalRegion);

      const result = filtered
        .GroupJoin(
          limitData,
          (k1) => k1.regionId,
          (k2) => k2.regionId,
          (ctry, k) => ({
            label: ctry.regionName, // .trim().replace(' ', '')
            data: '0',
            children: k.Select((a) => ({ label: a.country.countryName, data: a.regionCountryId.toString() })).ToArray(),
          })
        )
        .ToArray();

      return result as TreeNode[];
    }

    return [];
  }

  checkPeriodEnding(periodOfStudyFrom: number, periodOfStudyTo: number) {
    if (periodOfStudyFrom && periodOfStudyFrom > 0 && periodOfStudyTo && periodOfStudyTo > 0) {
      return !(periodOfStudyFrom <= periodOfStudyTo);
    }
    return false;
  }

  checkPeriodTimeFrame(periodOfStudyFrom: number, periodOfStudyTo: number) {
    if (periodOfStudyFrom && periodOfStudyFrom > 0 && periodOfStudyTo && periodOfStudyTo > 0) {
      return !(periodOfStudyTo - periodOfStudyFrom <= 10);
    }
    return false;
  }

  checkStudyDate() {
    if (this.study.displayStartDate && this.study.displayEndDate) {
      return this.study.displayEndDate <= this.study.displayStartDate;
    }
    return false;
  }
}
